import { useTranslation } from 'react-i18next';

import { MultiSelect } from '../../../../../../shared/components/UI/MultiSelect/MultiSelect';

import type { SelectPropertyProps } from './SingleSelectProperty';

export function MultiSelectProperty({
  bidResponse,
  vaultProperty,
  deleteBidResponseTag,
  createBidResponseTag,
}: SelectPropertyProps) {
  const { t } = useTranslation('bidResponse');

  const selectedOptionNames = bidResponse.properties
    .find(p => p.propertyId === vaultProperty.id)
    ?.values.map(v => v.name);

  const selectedOptions = vaultProperty.options.filter(option =>
    selectedOptionNames?.includes(option.name),
  );

  const handleChange = (selectedOptionIds: string[]) => {
    const deletedOption = selectedOptions.filter(
      option => !selectedOptionIds.includes(String(option.id)),
    );

    if (deletedOption.length > 0) {
      const deletedTag = bidResponse.properties
        .find(p => p.propertyId === vaultProperty.id)
        ?.values.find(v => v.name === deletedOption[0].name);

      if (deletedTag) {
        handleDelete(deletedTag.tagId);
      }
      return;
    }

    const newOptionId = Number(selectedOptionIds.at(-1));

    if (selectedOptions.some(option => option.id === newOptionId)) {
      return;
    }

    handleCreate(newOptionId);
  };

  const handleDelete = (tagId: number) => {
    deleteBidResponseTag({
      bidResponseId: bidResponse.id,
      propertyId: vaultProperty.id,
      tagId,
    });
  };

  const handleCreate = (optionId: number) => {
    createBidResponseTag({
      bidResponseId: bidResponse.id,
      propertyId: vaultProperty.id,
      optionId,
    });
  };

  const data = vaultProperty.options.map(option => ({
    value: String(option.id),
    label: option.name,
  }));

  return (
    <MultiSelect
      key={vaultProperty.id}
      variant="filled"
      tagColor={vaultProperty.color}
      label={vaultProperty.name}
      placeholder={t(
        'vault.sidepanels.bidResponse.input.property.multiSelect.placeholder',
      )}
      data={data}
      value={selectedOptions.map(option => String(option.id))}
      onChange={handleChange}
      searchable
      hoverOnSearchChange
      nothingFound={t(
        'vault.sidepanels.bidResponse.input.property.multiSelect.nothingFound',
      )}
    />
  );
}
